<section class="section-title">

  <h1 i18n="@@login_title">Area amministrativa web</h1>
  <p i18n="@@login_text">Benvenuto, inserisci le tue credenziali per accedere</p>

</section>

<section class="section-content">

  <div class="control-card-white no-border" id="login-card">

    <img class="login-logo" src="assets/img/logo_1control.svg" />

    <div class="control-card-content">

      <label for="userEmail" i18n="@@login_email">Indirizzo email</label>
      <input id="userEmail" type="text" placeholder="Email" #userEmail required autofocus
        (keyup.enter)="login(userEmail.value, userPassword.value)">

      <br /><br />

      <label for="userPassword" i18n="@@login_password">Password</label>
      <input id="userPassword" type="password" placeholder="Password" #userPassword required
        (keyup.enter)="login(userEmail.value, userPassword.value)">

      <br />

      <br /><br />

      <a (click)="login(userEmail.value, userPassword.value)" id="loginButton" class="button">
        <ng-container i18n="@@login_access">Accedi</ng-container> <span>
          <fa-icon icon="sign-in-alt"></fa-icon>
        </span>
      </a>
      <br />
      <p class="text-small text-error margin-top-10" id="wrongLogin" *ngIf="wrongLogin">
        <ng-container i18n="@@login_wrong_login">Credenziali errate</ng-container>
      </p>

      <!-- <a class="button float-right" (click)="register()">
        <ng-container i18n="@@login_register">Registrati</ng-container> <span><fa-icon icon="user"></fa-icon></span>
      </a> -->

    </div>

    <app-loading-screen #loginloader [loading]="false"></app-loading-screen>

    <a routerLink="/reset-password" class="display-block align-center margin-top-30 clickable">
      <ng-container i18n="@@login_password_lost">Ho dimenticato la password</ng-container>
    </a>

    <br /><br />

  </div>

</section>
